export const environment = {
  appVersion: '2023-01-12-v.1',
  production: true,
  drgvCategoryCreationDisabled: false,
  config: {
    APPINSIGHTS_INSTRUMENTATIONKEY: '994d425a-99b3-42fe-8eb6-2d8ee2e25a48',
    dataApiUrl: 'https://riapi.ppe.cloudmed.com/', // Data API
    functionAppUrl: 'https://rieppeassurancescalafunctionapp.azurewebsites.net',
    functionAppKey: 'VRFp/EL5OnZliQng/1Qtu5eF8VQ9aeaCBsYfkXkVgINq3WbsKoAvvA==',
    dataApiVersion: 'v1.13',
    auth0: {
      domain: 'auth.ppe.cloudmed.com',
      clientId: 'gpC62vjCbHlnWyyIZyxIB6YRJcKjzV5C',
      audience: 'ppe.cloudmed'
    }
  }
};
